export default window.config;
